const config = {};

config.apiURL = process.env.REACT_APP_API_URL || "https://medexwareapi-uhkmv5bohq-uc.a.run.app";
config.portalURL = process.env.REACT_APP_PORTAL_URL || "https://portal.medexware.com";
config.appName = process.env.REACT_APP_APP_NAME || "Medexware - Testing";
config.heplUrl = process.env.REACT_APP_HELP_URL || "https://idechsrl.com/archivos/InstructructivoAperturaEstudios.pdf";
config.VIEWPORT_CONFIG = process.env.REACT_APP_VIEWPORT_CONFIG || "http://209.188.7.174:3000/viewer";

export default config;
